import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

function OnlyOnFlaivySite(props) {
  const {
    shopConfig: { subdomain },
    children,
  } = props;
  const show =
    subdomain === 'flaivy' ||
    subdomain === 'dev2' ||
    subdomain === 'demo-privab-shop';

  if (show) {
    return <>{children}</>;
  }

  return <></>;
}

OnlyOnFlaivySite.propTypes = {
  shopConfig: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

function mapStateToProps(state) {
  const { shopConfig } = state;
  return { shopConfig };
}

export default connect(mapStateToProps)(OnlyOnFlaivySite);
